module.exports = __webpack_public_path__ + "static/media/home-networkin.bea2f2df.png";